import { PropsWithChildren } from "react";

import { Badge, Collapse, Group, Text, UnstyledButton } from "@mantine/core";
import { IconChevronRight } from "@tabler/icons-react";

import classes from "./styles.module.css";

type NavSectionHeaderProps = PropsWithChildren<{
  title: string;
  isCollapsed: boolean;
  onToggle: () => void;
  isMobile?: boolean;
  isActive?: boolean;
  badge?: string;
}>;

export function NavSectionHeader({
  title,
  isCollapsed,
  onToggle,
  children,
  isMobile = false,
  isActive = false,
  badge,
}: NavSectionHeaderProps) {
  const headerClass = isActive ? classes.sectionHeaderActive : classes.sectionHeader;
  const textClass = isActive
    ? classes.sectionHeaderTextActive
    : isMobile
      ? classes.sectionHeaderTextMobile
      : classes.sectionHeaderText;

  // Active sections should not be collapsible - they stay expanded
  const isCollapsible = !isActive;
  const effectiveCollapsed = isActive ? false : isCollapsed;

  const chevronClass = isActive
    ? classes.chevronActive
    : effectiveCollapsed
      ? classes.chevronCollapsed
      : classes.chevron;

  const handleClick = () => {
    if (isCollapsible) {
      onToggle();
    }
  };

  return (
    <>
      <UnstyledButton
        onClick={handleClick}
        className={headerClass}
        w="100%"
        style={{ cursor: isCollapsible ? "pointer" : "default" }}
      >
        <Group gap="xs" py="4px">
          <IconChevronRight
            size={12}
            className={chevronClass}
          />
          <Text
            size="11px"
            fw={isActive ? 700 : 600}
            tt="uppercase"
            className={textClass}
          >
            {title}
          </Text>
          {badge && (
            <Badge
              size="xs"
              variant="light"
              color="orange"
              tt="none"
              fw={600}
            >
              {badge}
            </Badge>
          )}
        </Group>
      </UnstyledButton>
      <Collapse in={!effectiveCollapsed}>{children}</Collapse>
    </>
  );
}
